export type EnterpriseDeployJob = {
  ok?: boolean;
  status?: string;
  job_id?: string;
  device_id?: string;
  edge_ip?: string;
  release_id?: string;
  bundle_hash?: string | null;
  model_bundle?: string;
  strict_profile?: string;
  acceptance?: {
    overall?: string;
    failures?: number;
    bundle_hash?: string;
    release_id?: string;
    [key: string]: unknown;
  };
  validation?: {
    ready_for_production?: boolean;
    acceptance_overall?: string | null;
    [key: string]: unknown;
  };
  acceptance_artifact_path?: string;
  error?: string;
  detail?: string;
  started_at?: string;
  finished_at?: string;
  steps?: Array<{ step?: string; status?: string; rc?: number | null }>;
  via?: string;
};

export type EnterpriseDeployDevice = {
  device_id?: string;
  ip_address?: string;
  device_metadata?: Record<string, unknown> | null;
};

export function resolveEnterpriseEdgeHost(device?: EnterpriseDeployDevice | null): string {
  const md = device?.device_metadata;
  const fromMeta =
    md && typeof md === 'object'
      ? String(md.health_api_host || md.ip_address || '').trim()
      : '';
  return fromMeta || String(device?.ip_address || '').trim();
}

export function defaultStrictProfileForDevice(device?: EnterpriseDeployDevice | null): string {
  const cooling = String(
    (device?.device_metadata as Record<string, unknown> | undefined)?.cooling || '',
  )
    .trim()
    .toLowerCase();
  if (cooling === 'fanless') return 'warehouse_v1_fanless';
  return 'warehouse_v1';
}

export function isEnterpriseJobRunning(job: EnterpriseDeployJob | null | undefined): boolean {
  const st = String(job?.status || '').toLowerCase();
  return st === 'running' || st === 'in_progress';
}

export function isEnterpriseJobTerminal(job: EnterpriseDeployJob | null | undefined): boolean {
  if (!job?.status) return false;
  return !isEnterpriseJobRunning(job);
}

export function enterpriseAcceptancePassed(job: EnterpriseDeployJob | null | undefined): boolean {
  const acceptance = job?.acceptance;
  if (!acceptance || typeof acceptance !== 'object') return false;
  const overall = String(acceptance.overall || '').toLowerCase();
  if (overall === 'fail') return false;
  try {
    if (Number(acceptance.failures || 0) > 0) return false;
  } catch {
    return false;
  }
  const st = String(job?.status || '').toLowerCase();
  return st === 'ok' || st === 'ok_with_warnings';
}

export function enterpriseJobChipColor(status: string): 'default' | 'success' | 'error' | 'warning' | 'info' {
  const st = status.toLowerCase();
  if (st === 'ok' || st === 'ok_with_warnings' || st === 'succeeded') return 'success';
  if (st === 'running' || st === 'in_progress') return 'info';
  if (st === 'error' || st === 'failed') return 'error';
  return 'default';
}
